import { render } from "./solution.vue?vue&type=template&id=36bc6772&scoped=true"
import script from "./solution.vue?vue&type=script&lang=ts"
export * from "./solution.vue?vue&type=script&lang=ts"

import "./solution.vue?vue&type=style&index=0&id=36bc6772&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36bc6772"

export default script